export default "__VITE_ASSET__B7tKu_DC__"